import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const fr = {
  common: {
    streamItem: 'Élément du flux',
    description: 'Description',
    httpMethod: 'Méthode HTTP',
    path: 'Chemin',
    copyDefault: 'Copier la valeur par défaut',
    copyExample: 'Copier la valeur d’exemple',
  },
  search: {
    label: 'Rechercher',
    inputLabel: 'Saisissez votre recherche',
    open: 'Ouvrir la recherche',
    placeholder: 'Rechercher...',
    clear: 'Effacer la recherche',
    noResults: 'Aucun résultat trouvé',
    keyboardShortcut: 'Raccourci clavier :',
    command: 'Commande',
    control: 'Contrôle',
    results: 'Résultats de recherche de la référence',
    navigate: 'Naviguer',
    select: 'Sélectionner',
    instructions:
      'Appuyez sur flèche haut ou bas pour naviguer, Entrée pour sélectionner, saisissez du texte pour filtrer les résultats',
    entryHeading: 'Titre',
    entryOperation: 'Opération',
    entryTag: 'Balise',
    entryTagGroup: 'Groupe de balises',
    entryWebhook: 'Webhook',
  },
  navigation: {
    introduction: 'Introduction',
    closeGroup: 'Fermer le groupe',
    closeMenu: 'Fermer le menu',
    openGroup: 'Ouvrir le groupe',
    openMenu: 'Ouvrir le menu',
    operations: 'Opérations',
    endpoints: 'Endpoints de {name}',
    showAllEndpoints: 'Afficher tous les endpoints de {name}',
    sidebarFor: 'Barre latérale pour {name}',
    mainContent: 'Documentation de l’API pour {name}',
    collapsed: 'Réduit',
    webhooks: 'Webhooks',
    channels: 'Canaux',
  },
  server: {
    label: 'Serveur',
    select: 'Sélectionner un serveur',
  },
  info: {
    termsOfService: 'Conditions d’utilisation',
  },
  asyncapi: {
    servers: 'Serveurs',
    protocols: 'Protocoles',
  },
  clientLibraries: {
    heading: 'Bibliothèques clientes',
    more: 'Plus',
    selectAll: 'Sélectionner parmi tous les clients',
  },
  operation: {
    codeSampleUnavailable: 'Aucun extrait de code disponible pour cet exemple.',
    body: 'Corps',
    cookies: 'Cookies',
    headers: 'En-têtes',
    pathParameters: 'Paramètres de chemin',
    queryParameters: 'Paramètres de requête',
    requestBody: 'Corps de la requête',
    responses: 'Réponses',
    testRequest: 'Tester la requête',
    webhook: 'Webhook',
    selectedContentType: 'Type de contenu sélectionné',
    callbacks: 'Callbacks',
  },
  response: {
    exampleResponses: 'Exemples de réponses',
    noBody: 'Aucun corps',
    showSchema: 'Afficher le schéma',
    status: 'Statut',
  },
  schema: {
    noAllowedValues: 'Aucune valeur ne satisfait cette contrainte enum.',
    example: 'Exemple',
    examples: 'Exemples',
    default: 'Par défaut',
    schema: 'Schéma',
    emptyObject: 'Objet vide',
    showAdditionalProperties: 'Afficher les propriétés supplémentaires',
    forName: 'pour {name}',
    showSchemaDetails: 'Afficher les détails du schéma',
    oneOf: 'Un parmi',
    anyOf: 'N’importe lequel parmi',
    allOf: 'Tous parmi',
    not: 'Non',
    unknownType: 'type inconnu',
    propertyCount: 'Propriétés : {count}',
    headerCount: 'En-têtes : {count}',
    recursiveReference: 'Référence récursive vers {name}',
    recursive: 'récursif',
    additionalProperties: 'propriétés supplémentaires',
    const: 'constante',
    deprecated: 'obsolète',
    discriminator: 'Discriminateur',
    enum: 'enum',
    format: 'Format',
    greaterThan: 'supérieur à',
    keys: 'clés',
    lessThan: 'inférieur à',
    max: 'max.',
    min: 'min.',
    maxLength: 'longueur max.',
    minLength: 'longueur min.',
    multipleOf: 'multiple de',
    nullable: 'nullable',
    propertyNames: 'noms des propriétés',
    pattern: 'Motif',
    copyPattern: 'Copier le motif',
    readOnly: 'lecture seule',
    required: 'obligatoire',
    hideValues: 'Masquer les valeurs',
    showAllValues: 'Afficher toutes les valeurs',
    type: 'Type',
    unique: 'unique',
    values: 'valeurs',
    writeOnly: 'écriture seule',
  },
  download: {
    openapi: 'Télécharger le document OpenAPI',
    asyncapi: 'Télécharger le document AsyncAPI',
  },
  models: {
    label: 'Modèles',
  },
  actions: {
    copyAsMarkdown: 'Copier en Markdown',
    copied: 'Copié',
    copyMarkdownFailed: 'Impossible de copier le Markdown',

    copyLink: 'Copier le lien',
    copyLinkTo: 'Copier le lien vers {name}',
    copyToClipboard: 'Copier le lien dans le presse-papiers',
    copyEndpointUrl: 'Copier l’URL de l’endpoint',
    showMore: 'Afficher plus',
  },
  agent: {
    askAi: 'Demander à l’IA',
    askAiAgent: 'Demander à l’agent IA',
    close: 'Fermer le client',
  },
  mcp: {
    generate: 'Générer MCP',
    connect: 'Connecter MCP',
  },
  developerTools: {
    title: 'Outils de développement',
    configure: 'Configurer',
    share: 'Partager',
    deploy: 'Déployer',
    scalarConfiguration: 'Configuration Scalar',
    theme: 'Thème',
    layout: 'Mise en page',
    layoutOptions: 'Options de mise en page',
    intro:
      'Les outils de développement vous permettent de personnaliser l’apparence et le comportement de votre documentation. Vous pouvez aussi partager votre documentation avec Scalar Registry.',
    disableToolbarBefore: 'Pour désactiver la barre d’outils, définissez',
    disableToolbarAfter: 'dans votre configuration.',
    localhostOnly: 'Les outils de développement apparaissent uniquement lors d’une exécution sur localhost.',
    layoutModern: 'Moderne',
    layoutClassic: 'Classique',
    showSidebar: 'Afficher la barre latérale',
    defaultOpenFirstTag: 'Ouvrir le premier tag par défaut',
    defaultOpenAllTags: 'Ouvrir tous les tags par défaut',
    expandAll: 'Tout développer pour {label}',
    expandAllResponses: 'Développer toutes les réponses',
    hideClientButton: 'Masquer le bouton client',
    hideDarkModeToggle: 'Masquer le sélecteur de mode sombre',
    hideModels: 'Masquer {label}',
    hideSearch: 'Masquer la recherche',
    showOperationId: 'Afficher l’ID d’opération',
    hideTestRequestButton: 'Masquer le bouton de requête de test',
    scalarDocs: 'Scalar Docs',
    deployDescription:
      'Déployez votre documentation sur Scalar, la plateforme moderne de documentation pour votre API et bien plus encore.',
    shareTitle: 'Partager votre API Reference',
    shareDescription:
      'Téléversez votre document OpenAPI pour partager votre API Reference avec d’autres personnes. Aussi simple qu’un clic.',
    uploadDocument: 'Téléverser le document',
    temporaryLinkExpiration: 'Votre document sera automatiquement supprimé après 7 jours.',
    deployOnScalar: 'Déployer sur Scalar',
    deployFree: 'Déployez votre documentation gratuitement.',
    additionalFeaturesMightRequire: 'Les fonctionnalités supplémentaires peuvent nécessiter',
    generate: 'Générer',
    passwordProtection: 'Protection par mot de passe',
    customDomains: 'Domaines personnalisés',
    freeFormContent: 'Contenu libre',
    cdnInfrastructure: 'Infrastructure CDN',
    pullFromGitHub: 'Import depuis GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Linting Spectral',
    jsonSchemaHosting: 'Hébergement JSON Schema',
    askAi: 'Demander à l’IA',
    mcpServers: 'Serveurs MCP',
    unableToExportDocument: 'Impossible d’exporter le document actif',
    unknownError: 'Une erreur inconnue est survenue',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      'Bienvenue dans Scalar API References + Swagger Editor, un outil gratuit et open source qui transforme votre fichier Swagger/OAS en belles API References.',
    showExample: 'Afficher l’exemple',
    uploadFile: 'Téléverser un fichier',
    integrations: 'INTÉGRATIONS',
    theming: 'THÈMES',
    features: 'Fonctionnalités',
    customize: 'Personnaliser',
    customizeDescription: 'Utilisez votre typographie et vos palettes de couleurs, ou nos thèmes !',
    testing: 'Tests',
    testingDescription: 'Un REST API Client profondément intégré (également gratuit et open source)',
    search: 'Recherche',
    searchDescription: 'Recherche entièrement intégrée (avec fuse.js)',
    hosting: 'Hébergement',
    hostingDescription: 'Hébergement gratuit sur un sous-domaine de https://apidocumentation.com',
    openApiSwagger: 'OpenAPI et Swagger',
    openApiSwaggerDescription: 'Prise en charge d’OpenAPI 3.1, OpenAPI 3.0 et Swagger 2.0',
    codeSamples: 'Exemples de code',
    codeSamplesDescription: 'Des exemples de code pour présenter votre API dans les langages les plus populaires',
  },
  footer: {
    poweredByScalar: 'Propulsé par Scalar',
  },
  authentication: {
    title: 'Authentification',
    accepts: 'Accepte',
    allOf: 'tous les éléments :',
    authentication: 'authentification',
    optional: 'Authentification optionnelle',
    oneOf: 'l’un des éléments :',
    required: 'Authentification requise',
    requires: 'Requiert',
    scopes: 'Portées OAuth',
  },
} satisfies ApiReferenceTranslations
